import { Box, Checkbox, Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { ShipmentType } from '../../../../../bff-api/baskets/model/ShipmentType';
import { useBopisSddFilterEnabled } from '../../../hooks/use-search/useBopisSddFilterEnabled';

interface FilterDeliveryOptionsProps {
    isBopisSelected: boolean;
    isSddSelected: boolean;
    onChangeBopisFilter: () => void;
    onChangeSddFilter: () => void;
    sddDescription: string;
}

export const FilterDeliveryOptions: React.FC<FilterDeliveryOptionsProps> = ({
    isBopisSelected,
    isSddSelected,
    onChangeBopisFilter,
    onChangeSddFilter,
    sddDescription,
}: FilterDeliveryOptionsProps) => {
    const { isBopisEnabled, isSddEnabled } = useBopisSddFilterEnabled();

    if (!isBopisEnabled && !isSddEnabled) {
        return null;
    }

    return (
        <Flex
            data-testid="search-filters-delivery-options"
            shrink={0}
            borderWidth={1}
            borderColor="slt-pepper.400"
            borderRadius={4}
        >
            {isBopisEnabled && (
                <Box
                    paddingX={4}
                    paddingY={3}
                    lineHeight="normal"
                    borderRightWidth={isSddEnabled ? 1 : 0}
                    borderColor="slt-pepper.400"
                >
                    <Checkbox
                        id="search-filters-bopis-checkbox"
                        size="base"
                        value={ShipmentType.BOPIS}
                        isChecked={isBopisSelected}
                        onChange={onChangeBopisFilter}
                        fontWeight="500"
                    >
                        <FormattedMessage
                            id="delivery_options.bopis.title"
                            defaultMessage="Store Pickup"
                        />
                    </Checkbox>
                </Box>
            )}

            {isSddEnabled && (
                <Box paddingX={4} paddingY={3} lineHeight="normal">
                    <Checkbox
                        id="search-filters-sdd-checkbox"
                        size="base"
                        value={ShipmentType.SAME_DAY_DELIVERY}
                        isChecked={isSddSelected}
                        onChange={onChangeSddFilter}
                        fontWeight="500"
                    >
                        {sddDescription}
                    </Checkbox>
                </Box>
            )}
        </Flex>
    );
};
